<template>
	<svg
		width="15px"
		height="18px"
		viewBox="0 0 15 18"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="participant mic off icon"
	>
		<g
			id="Meetings"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Watch-Meeting"
				transform="translate(-1384.000000, -287.000000)"
				fill="#787878"
				fill-rule="nonzero"
			>
				<g id="Group-5" transform="translate(1384.000000, 186.000000)">
					<path
						d="M10.5145139,110.092421 C10.5421594,109.907579 10.5605898,109.722738 10.5605898,109.529095 L10.5605898,104.309535 C10.5605898,102.364303 9.23360467,101 7.33527876,101 C5.62125634,101 4.39563815,102.109046 4.17447397,103.737408 L4.17447397,104.045477 L5.53831977,105.348166 L5.53831977,104.300733 C5.53831977,103.112469 6.24788819,102.329095 7.33527876,102.329095 C8.41345415,102.329095 9.12302258,103.112469 9.12302258,104.300733 L9.12302258,108.569682 C9.12302258,108.631296 9.1138074,108.701711 9.1138074,108.754523 L10.5145139,110.092421 Z M14.79957,116.535452 C15.06681,116.280196 15.06681,115.866504 14.79957,115.620049 L1.16111196,102.593154 C0.893871909,102.337897 0.460758716,102.337897 0.193518661,102.593154 C-0.0645062202,102.839609 -0.0645062202,103.262103 0.193518661,103.508557 L13.8411918,116.535452 C14.1084319,116.790709 14.5507603,116.790709 14.79957,116.535452 Z M11.260943,119 C11.6571955,119 11.9797266,118.691932 11.9797266,118.313447 C11.9797266,117.934963 11.6571955,117.635697 11.260943,117.635697 L8.03563201,117.635697 L8.03563201,115.778484 C9.04930118,115.690465 9.95238827,115.426406 10.7356781,114.99511 L9.70357856,114.018093 C9.03087083,114.343765 8.22915067,114.519804 7.33527876,114.519804 C4.34956228,114.519804 2.38673015,112.636186 2.38673015,109.801956 L2.38673015,108.182396 C2.38673015,107.803912 2.06419905,107.504645 1.66794655,107.504645 C1.27169406,107.504645 0.949162955,107.803912 0.949162955,108.182396 L0.949162955,109.854768 C0.949162955,113.181907 3.25295654,115.496822 6.62571034,115.778484 L6.62571034,117.635697 L3.40039932,117.635697 C3.00414683,117.635697 2.68161573,117.934963 2.68161573,118.313447 C2.68161573,118.691932 3.00414683,119 3.40039932,119 L11.260943,119 Z M13.1039779,112.56577 C13.5002304,111.773594 13.7121794,110.866993 13.7121794,109.854768 L13.7121794,108.182396 C13.7121794,107.803912 13.3896483,107.504645 12.9933958,107.504645 C12.5971433,107.504645 12.2746122,107.803912 12.2746122,108.182396 L12.2746122,109.801956 C12.2746122,110.418093 12.1732453,110.981418 11.9797266,111.491932 L13.1039779,112.56577 Z M7.33527876,112.847433 C7.68545538,112.847433 8.01720166,112.785819 8.31208724,112.688998 L6.91138074,111.3511 C6.84687452,111.377506 6.77315313,111.386308 6.69943173,111.386308 C6.19259714,111.280685 5.83320534,110.893399 5.71340808,110.400489 L5.7041929,110.198044 L4.10075257,108.666504 L4.10075257,109.529095 C4.10075257,111.48313 5.42773767,112.847433 7.33527876,112.847433 Z"
						id="Mic-Off"
					></path>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MicOffParticipant',
}
</script>
